import store from '../../../../store/configureStore';

import AirQualityDataItem from '../../../data/airQuality/AirQualityDataItem';
import AirQualityData from '../../../data/airQuality/index';

class ThingSpeakToAirQuality {
  constructor(initializer = {}, source_uid) {
    let aqdiObjs = [];
    if((source_uid)&&(initializer.channel)
        &&(initializer.channel.latitude)
        &&(!(isNaN(parseFloat(initializer.channel.latitude))))
        &&(initializer.channel.longitude)
        &&(!(isNaN(parseFloat(initializer.channel.longitude))))) {
      if(this.field_map === undefined) {
        this.field_map = {};
        (Object.entries(initializer.channel)).map(([key, value]) => {
          if(key.match(/field/i)) {
            if((value.match(/temp/i))){
              this.field_map[AirQualityDataItem.PARAMETERS.TEMP.key] = key;
            }
            if((value.match(/pm/i))||(value.match(/part/i))||(value.match(/dust/i))){
              if((value.match(/2.5/i)))
                this.field_map[AirQualityDataItem.PARAMETERS.PM2_5.key] = key;
              if((value.match(/10/i)))
                this.field_map[AirQualityDataItem.PARAMETERS.PM10.key] = key;
            }
            if((value.match(/hum/i))){
              this.field_map[AirQualityDataItem.PARAMETERS.HUM.key] = key;
            }
          }
        });
      }
      if((initializer.feeds)&&(initializer.feeds.length > 0)) {
        initializer.feeds.map((feed) => {
          let aqdiObj = {};
          aqdiObj["CHANNEL_ID"] = (initializer.channel.id).toString();
          aqdiObj["CHANNEL_NAME"] = initializer.channel.name;
          aqdiObj["SOURCE"] = "ThingSpeak";
          aqdiObj["SOURCE_ID"] = source_uid;
          aqdiObj["LOCATION"] = {
            lat: parseFloat(initializer.channel.latitude),
            lng: parseFloat(initializer.channel.longitude)
          };
          aqdiObj["ENTRY_ID"] = (feed.entry_id).toString();
          aqdiObj["SENSED_AT"] = new Date(feed.created_at);
          aqdiObj["MEASUREMENTS"] = {};
          (Object.entries(this.field_map)).map(([param, field]) => {
            let measurement = parseFloat(feed[field]);
            if(!(isNaN(measurement))) {
              aqdiObj["MEASUREMENTS"][param] = measurement;
            }
          });
          // aqdiObjs.push(new AirQualityDataItem(aqdiObj));
        });
        this.aqdiObjs = [].concat(aqdiObjs);
        store.dispatch({
          type: AirQualityData.ACTIONS.LOCK_AIR_QUALITY_RENDERING,
          id: (source_uid + '-' + initializer.channel.id)
        });
        store.dispatch({
          type: AirQualityData.ACTIONS.ADD_AIR_QUALITY_DATA_ITEMS,
          data: aqdiObjs
        });
        store.dispatch({
          type: AirQualityData.ACTIONS.UNLOCK_AIR_QUALITY_RENDERING,
          id: (source_uid + '-' + initializer.channel.id)
        });
      }
    }
    else if ((source_uid)&&(initializer.channel)&&(initializer.channel.id)) {
      store.dispatch({
        type: AirQualityData.ACTIONS.UNLOCK_AIR_QUALITY_RENDERING,
        id: (source_uid + '-' + initializer.channel.id)
      });
    }
  }
}

export default ThingSpeakToAirQuality;



// WEBPACK FOOTER //
// ./src/models/source/thingSpeak/interfaces/ThingSpeakToAirQuality.js